"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldWrapper = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var grid_1 = require("./grid");
var spacing_1 = require("./spacing");
var typography_1 = require("./typography");
var colors_1 = require("../util/colors");
var Label = styled_components_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  ", "\n"], ["\n  font-family: ", ";\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.baseType;
}, typography_1.rulesForTextProps);
var FieldContainer = (0, styled_components_1.default)(grid_1.Container)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  border-radius: 8px;\n"], ["\n  ", "\n  border-radius: 8px;\n"])), function (_a) {
    var fillBg = _a.fillBg;
    return (fillBg ? "background-color: ".concat(colors_1.colors.gray50, ";") : '');
});
var FieldWrapper = function (_a) {
    var label = _a.label, help = _a.help, error = _a.error, children = _a.children, _b = _a.required, required = _b === void 0 ? false : _b, wrapperProps = __rest(_a, ["label", "help", "error", "children", "required"]);
    var requiredPrefix = required && react_1.default.createElement(typography_1.Text, { color: colors_1.colors.red600 }, "* ");
    return (react_1.default.createElement(FieldContainer, __assign({ direction: "column" }, wrapperProps, { grow: true }),
        label && (react_1.default.createElement(spacing_1.Div, { pb: 1 },
            react_1.default.createElement(Label, { weight: 500 },
                requiredPrefix,
                label))),
        children,
        help && (react_1.default.createElement(typography_1.P, { pt: 1, color: colors_1.colors.gray600 }, help)),
        error && (react_1.default.createElement(typography_1.P, { pt: 1, error: true }, error))));
};
exports.FieldWrapper = FieldWrapper;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FieldWrapper.js.map